import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BunkerFlowDirection } from '../../types/api/profile';
import { useMessageStore } from '../../stores/useMessageStore';
import { HubsNames } from '../../stores/useSignalR';

export const FlowDirectionDisplay: React.FC = () => {
  const profileData = useMessageStore((state) => state?.messages[HubsNames.bunkeringDashboard]) as
    | any[]
    | undefined;

  const flowDirection = useMemo(() => {
    if (!profileData?.length) return undefined;
    
    const lastProfile = profileData[profileData.length - 1];
    return lastProfile?.data?.flowDirection;
  }, [profileData]);

  const getDisplayContent = (): React.ReactNode => {
    if (flowDirection === undefined || flowDirection === BunkerFlowDirection.Undefined) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            --
          </Typography>
          <Typography variant="body2">Non Applicable</Typography>
        </Box>
      );
    }

    return (
      <Typography variant="h4">
        {BunkerFlowDirection[flowDirection]}
      </Typography>
    );
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      {getDisplayContent()}
    </Box>
  );
}; 